@use "styles/abstracts/mixins/common" as m;
@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/variables" as v;

.modal {
  @include m.media(v.$container-desktop) {
    width: 100%;
    max-width: 100%;
  }
}

.wrapper {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  .columns {
    display: grid;
    grid-template-columns: 201px auto;
    margin-bottom: 24px;
    border-bottom: 1px solid v.$palette-dirty-20;

    @include m.media(v.$container-desktop) {
      grid-template-columns: 1fr;
      margin-bottom: 16px;
    }
  }

  .titleBox {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .title {
    margin: 0;
    @include t.text(18px, 28px, 600);
  }

  .helpCircle {
    cursor: pointer;
    flex-shrink: 0;

    circle {
      transition: v.$transition;
    }

    @media (pointer: fine) {
      &:hover {
        circle {
          fill: v.$palette-orange-2;
        }
      }
    }
  }

  .columnSpacing {
    padding: 16px 0;
    border-right: 1px solid v.$palette-dirty-20;
    min-width: 0;

    .titleBox {
      margin-bottom: 14px;
    }

    .spacingContent {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 8px;

      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 6px;
        max-width: 100%;

        svg {
          min-width: 100px;
          max-width: 100%;
          height: auto;
        }
      }
    }

    @include m.media(v.$container-desktop) {
      border-right: none;
      border-bottom: 1px solid v.$palette-dirty-20;
      padding: 12px 0 16px;
    }
  }

  .columnStuffing {
    padding: 16px;
    min-width: 0;

    .titleBox {
      margin-bottom: 36px;
    }

    .stuffingContent {
      display: grid;
      grid-template-columns: repeat(2, 264px);
      gap: 36px 40px;

      .item {
        display: flex;
        align-items: center;
        gap: 24px;
        min-width: 0;
        max-width: 100%;

        svg {
          min-width: 100px;
          flex-shrink: 0;
          max-width: 100%;
          height: auto;
        }
      }

      .fieldset {
        display: flex;
        flex-direction: column;
        gap: 8px;
        min-width: 0;
        flex: 1;
      }
    }

    @include m.media(v.$container-desktop) {
      padding: 16px 0;

      .titleBox {
        margin-bottom: 20px;
      }

      .stuffingContent {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 24px 16px;

        .item {
          gap: 16px;

          svg {
            min-width: 80px;
            width: 80px;
          }
        }
      }
    }

    @include m.media(v.$container-tablet) {
      .stuffingContent {
        grid-template-columns: 1fr;
        gap: 16px;

        .item {
          gap: 12px;

          svg {
            min-width: 72px;
            width: 72px;
          }
        }
      }
    }
  }

  .actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: wrap;

    @include m.media(v.$container-tablet) {
      width: 100%;

      button {
        flex: 1 1 auto;
        min-width: 0;
      }
    }

    button.save {
      color: v.$palette-white;
      background-color: v.$palette-orange-2;

      @media (pointer: fine) {
        &:hover {
          color: v.$palette-white;
          background-color: v.$palette-orange-3;
        }
      }
    }
  }
}

.tooltipContent {
  width: 320px;
  max-width: min(320px, calc(100vw - 48px));
  box-sizing: border-box;
}
